// extracted by mini-css-extract-plugin
export default {"container":"SearchResult_container__UA9nz","title":"SearchResult_title__BaKLk","association":"SearchResult_association__25ibd"};